import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export const useRecentAnalyses = (limit = 10) => {
    const [analyses, setAnalyses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchAnalyses = async () => {
        try {
            const { data, error } = await supabase
                .from('analyses_history')
                .select(`
                    id,
                    timestamp,
                    websites_analyzed,
                    matches_found,
                    errors_count,
                    primary_analysis_type_name,
                    secondary_analysis_type_name,
                    csv_result_url,
                    analysis_name,
                    status
                `)
                .order('timestamp', { ascending: false })
                .limit(limit);

            if (error) throw error;

            const formattedAnalyses = data.map(analysis => ({
                id: analysis.id,
                date: analysis.timestamp,
                analysisTypes: [
                    analysis.primary_analysis_type_name,
                    analysis.secondary_analysis_type_name
                ].filter(Boolean),
                websitesAnalyzed: analysis.websites_analyzed,
                matchesFound: analysis.matches_found,
                errorsCount: analysis.errors_count,
                resultUrl: analysis.csv_result_url,
                analysis_name: analysis.analysis_name,
                status: analysis.status || 'pending' // Default to 'pending' if status is null
            }));

            setAnalyses(formattedAnalyses);
            setError(null);
        } catch (err) {
            console.error('Error fetching analyses:', err);
            setError('Failed to load recent analyses');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAnalyses();

        // Set up real-time subscription
        const channel = supabase
            .channel('analyses_history_changes')
            .on('postgres_changes',
                {
                    event: '*',
                    schema: 'public',
                    table: 'analyses_history'
                },
                (payload) => {
                    console.log('Received real-time update:', payload);
                    fetchAnalyses();
                }
            )
            .subscribe((status) => {
                console.log('Subscription status:', status);
            });

        // Cleanup function
        return () => {
            channel.unsubscribe();
        };
    }, [limit]); // Only re-run if limit changes

    return { analyses, loading, error };
};